/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { troop_type_all } from './troop_type_all';
export type troop_carac_full = {
  type: troop_carac_full.type;
  size: number;
  agi: string | null;
  ap: string | null;
  att: string | null;
  of: string | null;
  str: string | null;
  M: string | null;
  A: string | null;
  BS: string | null;
  E: string | null;
  I: string | null;
  LD: string | null;
  S: string | null;
  T: string | null;
  W: string | null;
  WS: string | null;
  troop_type: troop_type_all | null;
};
export namespace troop_carac_full {
  export enum type {
    V1 = 'V1',
    V2 = 'V2',
    V3 = 'V3',
  }
}
